import React from "react";
import { useNavigate } from "react-router-dom";
import platformIcon from "assets/images/icons/socials/facebook.png";
import verifiedIcon from "assets/images/icons/socials/facebook-verified.png";
import downloadIcon from "assets/images/icons/utilities/download.png";
import SearchCard from "examples/Cards/SearchCard";

function FacebookResultCard({ result, isInSocialStash, fetchUsageData, canDownload, featureName, planRequired, usageRaw, isWorkflow }) {
  const navigate = useNavigate();

  /**
   * Navigate to the Social Stash page.
   */
  const handleViewInSocialStash = () => {
    navigate("/social-stash");
  };

  return (
    <SearchCard
      platformIcon={platformIcon}
      verifiedIcon={verifiedIcon}
      downloadIcon={downloadIcon}
      result={result}
      countLabel="Followers"
      isInSocialStash={isInSocialStash}
      onViewInSocialStash={handleViewInSocialStash}
      fetchUsageData={fetchUsageData}
      canDownload={canDownload}
      featureName={featureName}
      planRequired={planRequired}
      usageRaw={usageRaw}
      isWorkflow={isWorkflow}
    />
  );
}

export default FacebookResultCard;


